import { COU_httpGet } from '@/utils/http'

// 获取已成功铺货的商品id (全部)
async function GetAllMovedGoodsId() {
  const url = '/moveLog/allSuccessProID'
  const r = await COU_httpGet({ url })
  let list = [], map = {}
  try {
    list = r.result
  }
  catch(error) {
    console.log(error)
  }
  if (list?.length) {
    for (let item of list) {
      map[item.out_goods_id] = 1
    }
    Object.keys(map).length && sessionStorage.setItem('pdd_xiaofeng_shanghuo_is_moved_success_ids', JSON.stringify(map))
  }
  return Object.keys(map).length ? map : null
}

export {
  GetAllMovedGoodsId
}